import { Divider } from "@mui/material";
import HeaderWithFilter from "components/headerwithfilter";
import { State } from "data/reducers/state";
import { ShoppingActions } from "data/slices/shopping";
import { ShoppingStateProps } from "data/slices/shopping/interface";
import keys from "locale/keys";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import PURE from "widgets/dashboard/shopping";

import { Wrapper } from "../styled.components";

const ShoppingContainer = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { shopping, isFetching, isError, fetchedShopping } = useSelector<
    State,
    ShoppingStateProps
  >((state) => state.shopping);

  useEffect(() => {
    if (!fetchedShopping) {
      dispatch(ShoppingActions.request());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <HeaderWithFilter
        title={t(keys.shopping)}
        showFilter={false}
        showBackButton={false}
        showSearchField={false}
      />
      <Divider />
      <Wrapper>
        <PURE items={shopping} isError={isError} isFetching={isFetching} />
      </Wrapper>
    </>
  );
};

export default ShoppingContainer;
